(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meet-the-packers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    //Quick and slightly dirty read more because I don't have time

    const readMoreLinks = document.querySelectorAll('.js-read-more');
    const readLessButtons = document.querySelectorAll('.js-read-less');

    readMoreLinks.forEach(link => {
      link.addEventListener('click', function() {
        const cardBlock = this.closest('.card-block');
        const longText = cardBlock.querySelector('.packer-paragraphs-mobile-long');
        const shortText = cardBlock.querySelector('.packer-paragraphs-mobile-short');
        const readLess = cardBlock.querySelector('.js-read-less');

        if (longText.classList.contains('hidden')) {
          longText.classList.remove('hidden');
          shortText.classList.add('hidden'); 
        } else {
          longText.classList.add('hidden');
          shortText.classList.remove('hidden');
        }
        // Toggle visibility of read more and read less buttons
        this.classList.toggle('hidden');
        readLess.classList.remove('hidden');
      });
    });

    readLessButtons.forEach(button => {
      button.addEventListener('click', function() {
        const cardBlock = this.closest('.card-block');
        const longText = cardBlock.querySelector('.packer-paragraphs-mobile-long');
        const shortText = cardBlock.querySelector('.packer-paragraphs-mobile-short');
        const readMore = cardBlock.querySelector('.js-read-more');

        longText.classList.add('hidden');
        shortText.classList.remove('hidden');

        // Toggle visibility of read more and read less buttons
        this.classList.add('hidden');
        readMore.classList.remove('hidden');
      });
    });

    //Show/hide card based on the clicked grid block
    const gridBlocks = document.querySelectorAll('.meet-the-packers__grid .grid-block');
    const cardBlocks = document.querySelectorAll('.meet-the-packers__cards .card-block');

    gridBlocks.forEach(grid => {
      grid.addEventListener('click', function() {
        const blockId = this.getAttribute('data-block-id');

        // Remove active class from all grids and cards
        gridBlocks.forEach(g => g.classList.remove('active'));
        cardBlocks.forEach(c => c.classList.remove('active'));

        // Add active class to clicked grid and corresponding card
        this.classList.add('active');
        const correspondingCard = document.querySelector('.card-block[data-block-id="' + blockId + '"]');
        if (correspondingCard) {
          correspondingCard.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
